import { assign, get, has, isEmpty, reduce, set } from 'lodash';
import { stripHTML } from './sanitize';
import { renderToStaticMarkup } from 'react-dom/server';

function buildChoices(options, valueKey, labelKey, multi, placeholder) {
  const choices = reduce(options, (acc, option) => {
    const icon = renderToStaticMarkup(get(option, 'icon', ''));
    const label = stripHTML(get(option, labelKey, ''));
    const description = renderToStaticMarkup(get(option, 'description', ''));
    const choice = assign({}, {
      label: `${icon} ${label} ${description}`,
      value: stripHTML(get(option, valueKey, '')),
      disabled: get(option, 'disabled'),
    });
    if (has(option, 'children') && !isEmpty(option.children)) {
      const children = buildChoices(option.children, valueKey, labelKey);
      set(choice, 'choices', children);
    }
    return [...acc, choice];
  }, []);
  if (!multi && placeholder) {
    return [
      {
        label: placeholder,
        value: '',
        placeholder: true,
      },
      ...choices,
    ];
  }
  return choices;
}

export default buildChoices;
